// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Services =====
import getCurrentActionOrigin    from './getCurrentActionOrigin';

// ===== Interfaces =====

import {
    IBookInviteActionResult,
    ICreateBookInvitePayload,
}                               from '../interfaces';

const createBookInvite = async ({
    test,
    recipientEmail,
    recipientName,
    inviteMessage,
}: {
    test: boolean,
    recipientEmail: string,
    recipientName?: string,
    inviteMessage?: string,
}): Promise<IBookInviteActionResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        ICreateBookInvitePayload,
        IBookInviteActionResult
    >(
        functions,
        'createBookInvite',
    );
    const actionOrigin = getCurrentActionOrigin();
    const payload: ICreateBookInvitePayload = {
        test,
        recipientEmail,
        recipientName,
        inviteMessage,
    };
    if (actionOrigin) payload.actionOrigin = actionOrigin;
    return callable(payload).then((result) => result.data as IBookInviteActionResult);
};

export default createBookInvite;
